module.exports = __webpack_public_path__ + "media/bootstrap-icons/sim-7b57e28c.svg";